import { Navigate } from '@sorare/routing';
import { ANY_SPORT_MY_CLUB_SLUG } from '@sorare/core/src/constants/__generated__/routes';
import { useCurrentUserContext } from '@sorare/core/src/contexts/currentUser';
import { useSportContext } from '@sorare/core/src/contexts/sport';
import { requireAuth } from '@sorare/core/src/routing/RequireAuth';

const MyClubPage = () => {
  const { generateSportContextPath, sport } = useSportContext();
  const { currentUser } = useCurrentUserContext();
  if (!currentUser) {
    return null;
  }

  return (
    <Navigate
      replace
      to={generateSportContextPath(ANY_SPORT_MY_CLUB_SLUG, {
        sport,
        params: {
          slug: currentUser.slug,
        },
      })}
    />
  );
};

export default requireAuth(MyClubPage);
